import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StoryblokLinkDirective } from 'src/app/directive/storyblok-link.directive';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';

@Component({
    selector: 'app-link',
    imports: [
        CommonModule,
        RouterModule,
        StoryblokLinkDirective,
        StoryblokDirective,
    ],
    templateUrl: './link.component.html',
    styleUrl: './link.component.scss'
})
export class LinkComponent {
  @Input() _uid!: string;
  @Input() component!: any;
  @Input() _editable!: string;
  @Input() _active: boolean = false;
  @Input() hidden: any;
  @Input() text!: any;
  @Input() link!: any;
}
